export default "__VITE_ASSET__172e262e__$_?component__"